<template>
    <v-dialog
        v-model="$props.params.addEditTimeConditionDialog"
        max-width="600px"
        transition="dialog-bottom-transition"
        @keydown.esc="closeAddEditTimeConditionDialog()"
        @click:outside="closeAddEditTimeConditionDialog()"
    >
        <v-card>
            <v-form @submit.prevent="processAddEditTimeCondition()">

                <v-toolbar
                    :class="dialogHeadingClasses()"
                    color="primary"
                    dark
                >
                    <v-icon v-if="$props.params.mode === 'add'" class="mr-3"
                            v-text="icons.mdiPlusCircleOutline"></v-icon>
                    <v-icon v-else class="mr-3" v-text="icons.mdiPencilCircleOutline"></v-icon>
                    <div v-if="$props.params.mode === 'add'" v-text="$gettext('Add Time Condition')"></div>
                    <div v-else-if="$props.params.mode === 'edit'" v-text="$gettext('Edit Time Condition')"></div>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" v-text="icons.mdiClose"
                            @click.native.stop="closeAddEditTimeConditionDialog()"></v-icon>
                    <v-icon v-text="icons.mdiContentSave" @click.native.stop="processAddEditTimeCondition()"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div>
                                    <!--                                    :label="(strictEnd === 1) ? $gettext('Strict End') : $gettext('Not a Strict End')"-->
                                    <v-switch v-model="flexible"
                                              :false-value="false"
                                              :true-value="true"
                                              :value="false"
                                              class="mt-0 transition-ease-in-out"
                                              color="primary"
                                              inset
                                              :label="!flexible ? $gettext('Time based') : $gettext($gettext('Quota based'))"
                                              persistent-hint
                                              :hint="!flexible ? $gettext('A fixed time window. e.g. from 4pm to 6pm only') : $gettext('Overall time allowed for a ') + (weekly ? $gettext('week') : $gettext('day')) + $gettext('. e.g. 2 hours anytime during a ') + (weekly ? $gettext('week') : $gettext('day'))"
                                    ></v-switch>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <p class="subtitle-1 mb-0">{{ $gettext('Please pick the day(s)') }}</p>
                            </v-col>
                            <v-col cols="12" md="6"
                                   sm="12"
                            >
                                <div>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Monday')"
                                        class="mt-0"
                                        color="primary"
                                        hide-details
                                        required
                                        value="1"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Tuesday')"
                                        color="primary"
                                        hide-details
                                        required
                                        value="2"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Wednesday')"
                                        color="primary"
                                        hide-details
                                        value="3"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Thursday')"
                                        color="primary"
                                        hide-details
                                        value="4"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                </div>
                            </v-col>

                            <v-col cols="12" md="6"
                                   sm="12"
                            >
                                <div>
                                    <v-checkbox v-model="addTimeConditionDays"
                                                :error-messages="addTimeConditionDaysErrors"
                                                :label="$gettext('Friday')"
                                                class="mt-0"
                                                color="primary"
                                                hide-details
                                                value="5"
                                                @blur="$v.addTimeConditionDays.$touch()"
                                                @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Saturday')"
                                        color="primary"
                                        hide-details
                                        value="6"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="addTimeConditionDays"
                                        :error-messages="addTimeConditionDaysErrors"
                                        :label="$gettext('Sunday')"
                                        color="primary"
                                        hide-details
                                        value="7"
                                        @blur="$v.addTimeConditionDays.$touch()"
                                        @input="$v.addTimeConditionDays.$touch()"
                                    ></v-checkbox>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row v-if="isNotFlexible" class="mt-4">
                            <v-col cols="12" md="6">
                                <div>
                                    <v-text-field
                                        v-model="addScheduleFrom"
                                        :error-messages="addScheduleFromErrors"
                                        :label="$gettext('From')"
                                        format="24hr"
                                        outlined
                                        type="time"
                                        @blur="$v.addScheduleFrom.$touch()"
                                        @input="$v.addScheduleFrom.$touch()"
                                    ></v-text-field>
                                </div>
                            </v-col>

                            <v-col cols="12" md="6">
                                <div>
                                    <v-text-field
                                        v-model="addScheduleTo"
                                        :error-messages="addScheduleToErrors"
                                        :label="$gettext('To')"
                                        format="24hr"
                                        outlined
                                        type="time"
                                        @blur="$v.addScheduleTo.$touch()"
                                        @input="$v.addScheduleTo.$touch()"
                                    ></v-text-field>
                                </div>
                            </v-col>

                        </v-row>

                        <v-row v-if="isFlexible" class="mt-4">
                            <v-col cols="12">
                                <v-text-field
                                    v-model="timeAllowed"
                                    :error-messages="timeAllowedErrors"
                                    :label="$gettext('Overall Time Allowed (HH:MM)')"
                                    outlined
                                    placeholder="HH:MM"
                                    @blur="$v.timeAllowed.$touch()"
                                    @input="$v.timeAllowed.$touch()"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
<!--                                <v-switch v-model="weekly"
                                          :false-value="false"
                                          :label="weekly ? $gettext('Weekly') : $gettext('Daily')"
                                          :true-value="true"
                                          :value="false"
                                          class="mt-0 transition-ease-in-out"
                                          color="primary"
                                          inset
                                ></v-switch>-->
                                <v-select v-model="weekly" :items="[{text: 'Daily', value: false}, {text: 'Weekly', value: true}]" item-text="text" item-value="value"
                                          outlined
                                          :label="$gettext('Select the type of quota')"
                                >
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="py-0" cols="12">
                                <div>
                                    <!--                                    :label="(strictEnd === 1) ? $gettext('Strict End') : $gettext('Not a Strict End')"-->
                                    <v-switch v-model="strictEnd"
                                              :class="{'o-60': strictEnd !== 1}"
                                              :false-value="0"
                                              :true-value="1"
                                              class="mt-0 transition-ease-in-out"
                                              color="primary"
                                              inset
                                              label="Strict End"
                                              value="1"
                                    ></v-switch>
                                </div>
                            </v-col>
                        </v-row>


                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native.stop="closeAddEditTimeConditionDialog()">
                        {{ $gettext('Close') }}
                    </v-btn>
                    <v-btn color="primary" type="submit">
                        {{ $gettext('Save') }}
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}
</style>

<script>

import Vue from 'vue'
import {find, findIndex, size} from 'lodash'

import Vuelidate from 'vuelidate'
import {required, minLength, maxLength, between, requiredIf} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigRules from '@/mixins/database/MixinConfigRules'
import MixinLodashPadStart from '@/mixins/lodash/MixinLodashPadStart'
import {mapWritableState} from 'pinia'
import {useRulesStore} from '@/stores/RulesStore'

Vue.use(Vuelidate)
const mustHaveAnElement = (value) => value.length > 0

export default {
    components: {Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigRules, MixinLodashPadStart],
    props: {
        params: {
            required: true,
            type: Object | Array,
        },
    },
    mounted() {
        let self = this

        if (self.$props.params.mode === 'edit') {

            self.addTimeConditionDays = []

            let tempAddTimeConditionDays = []

            // loop over each character
            for (var i = 0; i < self.$props.params.currentTimeCondition?.days?.length; i++) {
                tempAddTimeConditionDays.push(self.$props.params.currentTimeCondition?.days?.charAt(i))
            }

            self.addTimeConditionDays = tempAddTimeConditionDays
            self.addScheduleFrom = self.padStart(self.$props.params.currentTimeCondition?.from)
            self.addScheduleTo = self.padStart(self.$props.params.currentTimeCondition?.to)
            self.strictEnd = self.$props.params.currentTimeCondition?.strict_end
            self.duration = self.$props.params.currentTimeCondition?.duration
            self.flexible = self.$props.params.currentTimeCondition?.flexible
            self.timeAllowed = self.padStart(self.$props.params.currentTimeCondition?.time_allowed)
            self.weekly = self.$props.params.currentTimeCondition?.weekly

        } else {
            self.strictEnd = self.getDefaultStrictEndValue()
        }

    },
    data() {
        return {
            addTimeConditionDays: [],

            addScheduleFrom: '',
            addScheduleTo: '',

            weekdays: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
            strictEnd: '',

            duration: 60,

            timeAllowed: '',
            flexible: false,
            weekly: false,

        }
    },
    methods: {

        processAddEditTimeCondition() {

            let self = this

            self.$v.$touch()

            if (!self.$v.$invalid) {

                if (self.$props.params.mode === 'add') {
                    self.$parent.addTimeCondition(self.$parent.currentSelectedRuleKey, self.addTimeConditionDays, self.addScheduleFrom, self.addScheduleTo, self.strictEnd, self.flexible, self.timeAllowed, self.weekly)
                    self.$parent.$refs.snackbar.showSnackbar(self.$gettext('Time condition added successfully'))
                } else if (self.$props.params.mode === 'edit') {
                    self.$parent.editTimeCondition(self.$parent.currentSelectedRuleKey, self.$props.params.tcIndex, self.addTimeConditionDays, self.addScheduleFrom, self.addScheduleTo, self.strictEnd, self.flexible, self.timeAllowed, self.weekly)
                    self.$parent.$refs.snackbar.showSnackbar(self.$gettext('Time condition updated successfully'))
                }


                self.closeAddEditTimeConditionDialog()

            }

        },
        closeAddEditTimeConditionDialog() {
            let self = this
            self.$parent.closeDialog('addEditTimeConditionDialog')
        },
        resetForm() {
            let self = this
            self.$v.$reset()
            self.addTimeConditionDays = []
            self.addScheduleFrom = ''
            self.addScheduleTo = ''
            self.duration = 60
            self.strictEnd = self.getDefaultStrictEndValue()
            self.flexible = false
            self.timeAllowed = ''
            self.weekly = false
        },

        isValidDuration(value) {
            // Simple regex to validate HH:MM format
            const pattern = /^([0-9]{1,2}):([0-5][0-9])$/;
            const isValid = pattern.test(value);

            return isValid;
        },
    },
    computed: {
        formattedDuration() {
            const hours = Math.floor(this.duration / 60);
            const minutes = this.duration % 60;
            return `${hours} hours ${minutes} minutes`;
        },
        isFlexible() {
            return this.flexible
        },
        isNotFlexible() {
            return !this.flexible
        },
        addTimeConditionDaysErrors() {
            const errors = []
            if (!this.$v.addTimeConditionDays.$dirty) return errors
            !this.$v.addTimeConditionDays.required && errors.push(this.$gettext('Please choose the days.'))
            return errors
        },

        addScheduleFromErrors() {
            const errors = []
            if (!this.$v.addScheduleFrom.$dirty) return errors
            !this.$v.addScheduleFrom.required && errors.push(this.$gettext('Please provide the From value.'))
            return errors
        },
        timeAllowedErrors() {
            const errors = [];
            if (!this.$v.timeAllowed.$pending && this.$v.timeAllowed.$dirty) {
                if (!this.$v.timeAllowed.required) {
                    errors.push(this.$gettext('Time allowed is required'));
                }
                if (!this.$v.timeAllowed.isValidDuration) {
                    errors.push(this.$gettext('Please provide a valid duration in HH:MM format'));
                }
            }
            return errors;
        },
        addScheduleToErrors() {
            const errors = []
            if (!this.$v.addScheduleTo.$dirty) return errors
            !this.$v.addScheduleTo.required && errors.push(this.$gettext('Please provide the to value.'))
            return errors
        },

    },
    validations: {
        addTimeConditionDays: {
            required
        },
        addScheduleFrom: {
            required: requiredIf(function () {
                return this.isNotFlexible
            }),
        },
        addScheduleTo: {
            required: requiredIf(function () {
                return this.isNotFlexible
            }),
        },
        timeAllowed: {
            required: requiredIf(function () {
                return this.isFlexible
            }),
            isValidDuration: function (value) {
                return !this.isFlexible || this.isValidDuration(value);
            },
        },
    }

}
</script>
